import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { CssBaseline, ThemeProvider } from "@mui/material";
import {App} from './App';
import "./utils/sentry";
import {AssessmentUserProvider} from './contexts/assessmentUserContext';
import {AssessmentContentProvider} from './contexts/assessmentContentContext';
import { theme } from "./theme/theme";

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found.');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <AssessmentUserProvider>
      <AssessmentContentProvider>
        <App />
      </AssessmentContentProvider>
    </AssessmentUserProvider>
    </ThemeProvider>
  </StrictMode>
);
